import { useEffect, useState } from "react";

import useCustomSelector from "@redux/hooks/useCustomSelector";
import useActionCreator from "@redux/hooks/useActionCreator";

import { AnnualProcurementPlanState } from "@reducers/types/procurements/annual-procurement-plan-state";

interface UseAnnualProcurementPlan {
  annualProcurementPlanState: AnnualProcurementPlanState;
}

export const useAnnualProcurementPlan = (
  id: number | string,
): UseAnnualProcurementPlan => {
  const { appByIdFetchActionHandler } = useActionCreator();

  const annualProcurementPlanState = useCustomSelector(
    (store) => store.procurements.annualProcurementPlanState,
  );

  useEffect(() => {
    if (id) appByIdFetchActionHandler(id);
  }, [id]);

  return {
    annualProcurementPlanState,
  };
};
